// Login.js
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";

export default function Login({ switchToRegister }) {
  const { login } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate(); // <-- for redirect after login

  const handleLogin = async () => {
    try {
      setError("");
      await login(email, password); // call AuthContext login
      navigate("/dashboard");       // <-- redirect to Dashboard
    } catch (err) {
      setError(err.response?.data?.error || "Login failed");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <center><h2 style={{ color: "navy" }}>Welcome to U2U Job Portal Login</h2> </center>
      <center><h3>This portal is for final year students seeking Internship/Fresher/Graduate Level Jobs</h3></center>
      <center><h4 style={{ color: "navy" }}>*Registration is Mandatory before Login</h4></center>
      <br></br>
         <br></br>
            <br></br>
      <center>
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <button onClick={handleLogin}>Login</button>
      {error && <p style={{ color: "red" }}>{error}</p>}
      </center>
      <center>
      <p>
        Don't have an account?{" "}
        <button onClick={switchToRegister}>Register</button>
      </p>
      </center>
         <br></br>
            <br></br>
               <br></br>
      <center><h4>Copyright: www.u2uacademy.com</h4></center>
    </div>
  );
}